/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';

export const QueueLoadingSkeleton = (): React.JSX.Element => {
	return <Spinner />;
};
